
export const getDeviceStatus = (lastSeen: string | null, status: string | null = null): 'active' | 'inactive' | 'pending' | 'unenrolled' => {
  // If there's an explicit unenrolled status, respect it
  if (status === 'unenrolled') return 'unenrolled';
  
  // If there's an explicit pending status, respect it
  if (status === 'pending') return 'pending';
  
  // If there's no lastSeen timestamp, the device hasn't checked in yet
  if (!lastSeen) return 'inactive';
  
  const lastSeenDate = new Date(lastSeen);
  const now = new Date();
  const minutesDifference = (now.getTime() - lastSeenDate.getTime()) / (1000 * 60);
  
  console.log('Status calculation:', {
    lastSeen,
    lastSeenDate,
    now,
    minutesDifference,
    status
  });
  
  // If device has an explicit active status and has been seen in the last 24 hours, keep it active
  if (status === 'active' && minutesDifference <= 1440) {
    return 'active';
  }
  
  // If device has been seen in the last 4 hours, mark as active regardless of status
  if (minutesDifference <= 240) {
    return 'active';
  }
  
  // Otherwise mark as inactive
  return 'inactive';
};

// Add function to format time ago
export const getTimeAgo = (timestamp: string): string => {
  const now = new Date();
  const date = new Date(timestamp);
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  
  // Less than a minute
  if (seconds < 60) {
    return 'less than a minute ago';
  }
  
  // Less than an hour
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  }
  
  // Less than a day
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `about ${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }
  
  // Days
  const days = Math.floor(hours / 24);
  if (days === 1) {
    return '1 day ago';
  }
  
  return `${days} days ago`;
};
